/**
 * Acquisition check fields mapping
 */
export const AcquisitionCheckFields: Record<string, string> = {
  organisationName: 'organisationCheck',
  issuedDate: 'issuedCheck',
  PO: 'POCheck',
  ref: 'refCheck',
  faceValue: 'faceValueCheck',
  expectedDate: 'expectedDateCheck',
  etrFile: 'etrCheck',
  organisationFile: 'organisationFileCheck',
  PoFile: 'POFileCheck',
  PoDFile: 'PoDCheck',
  signedFile: 'signedCheck',
  fxFile: 'fxFileCheck',
  proofFile: 'proofCheck',
};

/**
 * Acquisition file fields mapping
 */
export const AcquisitionFileFields: Record<string, string> = {
  POFileCheck: 'POFile',
  PoDCheck: 'PoDFile',
  etrCheck: 'etrFile',
  fxFileCheck: 'fxFile',
  organisationFileCheck: 'organisationFile',
  proofCheck: 'proofFile',
  signedCheck: 'signedFile',
};

/**
 * Acquisition columns settings by type
 */
export const AcquisitionColumnsSettingsByType: any = {
  'a-ETR': ['ETR', 'EDSO', 'expectedDate', 'TVn'],
  'b-ETR': ['issuedDate', 'EDSO', 'TVn'],
  'c-ETR': ['ETR', 'expectedDate', 'TVn'],
  'd-ETR': ['issuedDate', 'ETR', 'EDSO', 'TVn'],
  'f-ETR': ['ETR', 'EDSO', 'expectedDate', 'TVn'],
  // @todo need to check for this types
  'RSA': ['ETR', 'EDSO', 'expectedDate', 'TVn'],
  'Credit Note': ['ETR', 'EDSO', 'expectedDate', 'TVn'],
};

/**
 * Acquisition columns that need to be checked by type
 */
export const AcquisitionNeedToCheckColumnsByType: any = {
  'a-ETR': ['organisationCheck', 'etrCheck', 'tvnCheck', 'issuedCheck', 'faceValueCheck'],
  'b-ETR': ['organisationCheck', 'etrCheck', 'tvnCheck', 'faceValueCheck', 'etrCheck', 'expectedDateCheck'],
  'c-ETR': ['organisationCheck', 'etrCheck', 'tvnCheck', 'faceValueCheck', 'etrCheck', 'expectedDateCheck'],
  'd-ETR': ['organisationCheck', 'etrCheck', 'tvnCheck', 'faceValueCheck', 'etrCheck', 'expectedDateCheck'],
  'f-ETR': ['organisationCheck', 'etrCheck', 'tvnCheck', 'issuedCheck', 'faceValueCheck'],
  // @todo need to check for this types
  'RSA': ['organisationCheck', 'etrCheck', 'tvnCheck', 'issuedCheck', 'faceValueCheck'],
  'Credit Note': ['organisationCheck', 'etrCheck', 'tvnCheck', 'issuedCheck', 'faceValueCheck'],
};

/**
 * Flash message type definitions
 */
export const FlashMessageType = {
  Error: {
    text: 'alert-danger',
    label: 'Error',
    icon: 'bi-x-circle-fill',
  },
  Warning: {
    text: 'alert-warning',
    label: 'Warning',
    icon: 'bi-exclamation-triangle-fill',
  },
  Success: {
    text: 'alert-success',
    label: 'Success',
    icon: 'bi-check-circle-fill',
  },
  Info: {
    text: 'alert-info',
    label: 'Info',
    icon: 'bi-info-circle-fill',
  },
};
